module.exports = __webpack_public_path__ + "d50d9a09f78be5f83ff3bfc5448e8569.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/new_owl_1.png
// module id = 1735
// module chunks = 0